import React from 'react';

interface Props {
    children: React.ReactNode
    className?: string
    alignment?: "left" | "center" | "right"
}

const Text = ({children, className="", alignment = "center"}: Props) => {
    return (
        <p className={`text-${alignment} pt-2 font font-lora ${className}`}>{children}</p>
    )
}

export default Text;